import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProjeto } from '@/contexts/projeto-hook';
import { useI18n } from '@/contexts/i18n-hook';

interface ProjetoRouteProps {
  children: ReactNode;
}

export function ProjetoRoute({ children }: ProjetoRouteProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { projeto, loading } = useProjeto();
  const { t } = useI18n();

  useEffect(() => {
    if (!loading && !projeto) {
      navigate('/projeto-selecao');
    }
  }, [projeto, loading, navigate]);

  // Projeto de budget não tem dashboard/apreciações/etc — só a tela de budget
  useEffect(() => {
    if (!loading && projeto?.tipoProjeto === 'budget' && !location.pathname.startsWith('/budget')) {
      navigate('/budget', { replace: true });
    }
  }, [projeto, loading, location.pathname, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-schmersal-gray-light dark:bg-schmersal-gray-darkest">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-schmersal-blue mx-auto mb-4"></div>
          <p className="text-schmersal-gray-medium dark:text-schmersal-gray-light">
            {t('comum.estado.carregando')}
          </p>
        </div>
      </div>
    );
  }

  if (!projeto) {
    return null;
  }

  return <>{children}</>;
}





